import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { authService, cryptoPaymentService, paymentService } from '../services/api';
import '../styles/Donate.css';

const DonateReturn: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [message, setMessage] = useState('Confirmando seu pagamento...');
    const [success, setSuccess] = useState<boolean | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!authService.isAuthenticated()) {
            navigate('/login');
            return;
        }

        const run = async () => {
            const status =
                searchParams.get('status') ||
                searchParams.get('collection_status') ||
                '';

            const orderId = searchParams.get('order_id') || undefined;
            const isCrypto = searchParams.get('provider') === 'crypto' || !!orderId;

            const paymentId =
                searchParams.get('payment_id') ||
                searchParams.get('collection_id') ||
                undefined;

            const preferenceId = searchParams.get('preference_id') || undefined;
            const externalReference = searchParams.get('external_reference') || undefined;

            if (status === 'failure' || status === 'rejected') {
                setSuccess(false);
                setMessage('Pagamento não concluído. Tente novamente ou escolha outro método.');
                setLoading(false);
                return;
            }

            if (isCrypto && orderId) {
                try {
                    const result = await cryptoPaymentService.reconcileReturn(orderId);
                    setSuccess(result.success);
                    setMessage(result.message);
                } catch (e: any) {
                    setSuccess(false);
                    setMessage(
                        e?.response?.data?.message ||
                            'Não foi possível confirmar o pagamento automaticamente. Se o valor foi enviado, o cash será creditado após a confirmação na rede.'
                    );
                } finally {
                    setLoading(false);
                }
                return;
            }

            if (!paymentId && status === 'pending') {
                setSuccess(null);
                setMessage('Pagamento pendente. O cash será creditado assim que for confirmado.');
                setLoading(false);
                return;
            }

            try {
                const result = await paymentService.reconcileReturn({
                    paymentId,
                    preferenceId,
                    externalReference,
                });

                setSuccess(result.success);
                setMessage(result.message);
            } catch (e: any) {
                setSuccess(false);
                setMessage(
                    e?.response?.data?.message ||
                        'Não foi possível confirmar o pagamento automaticamente. Se o valor foi debitado, contate o suporte.'
                );
            } finally {
                setLoading(false);
            }
        };

        run();
    }, [navigate, searchParams]);

    return (
        <div className="donate-page">
            <div className="container" style={{ maxWidth: 560, margin: '0 auto', paddingTop: 40 }}>
                <div className="donate-table" style={{ padding: 24, textAlign: 'center' }}>
                    <h1 className="donate-title" style={{ fontSize: 28, marginBottom: 16 }}>
                        {loading ? 'Processando...' : success ? 'Pagamento confirmado' : success === false ? 'Pagamento' : 'Aguardando confirmação'}
                    </h1>
                    <p style={{ marginBottom: 24, color: 'var(--text-secondary)' }}>{message}</p>
                    <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Link to="/usercp" className="donate-btn-primary" style={{ textDecoration: 'none', padding: '12px 24px' }}>
                            Ir ao painel
                        </Link>
                        <Link to="/donate" className="donate-btn-primary" style={{ textDecoration: 'none', padding: '12px 24px', background: 'transparent', border: '1px solid var(--border-light)' }}>
                            Voltar à doação
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DonateReturn;
